import { render, staticRenderFns } from "./agent_flow_session_message.vue?vue&type=template&id=53b98983"
import script from "./agent_flow_session_message.vue?vue&type=script&lang=js"
export * from "./agent_flow_session_message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports